<template>
  <div class="profile">
    <h1>Assets</h1>
    <v-container grid-list-md text-center>
      <v-layout row wrap>
        <v-flex xs6>
        </v-flex>
        <v-flex xs6>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {},
  apollo: {},
  computed: {}
}
</script>

<style scoped>
</style>
